import usePageTracking from '../../assets/custom-hooks/track-page';
// import FeedbackBox from '../feedback-box/feedback-box.component';

const RoundtableRoute = ({children}) => {
    usePageTracking();
    return ( 
        <>
            {children}
            {/* <FeedbackBox/> */}
        </>
    )
}

export default RoundtableRoute;